import { useState } from 'react';
import DSDialog from '../../design-system/DSDialog';
import DSDialogActions from '../../design-system/DSDialogActions';
import DSPrimaryButton from '../../design-system/DSPrimaryButton';
import DSSecondaryButton from '../../design-system/DSSecondaryButton';
import DSBox from '../../design-system/DSBox';
import DSTextField from '../../design-system/DSTextField';
import { DSTypography } from '../../design-system/Typography';
import giftClient, { GiftInformation } from '../../api/gift';
import DSCircularProgress from '../../design-system/DSCircularProgress';
import { KLYDO_BLACK } from '../../consts/colors';

export type EnterOrderDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (giftInfo: GiftInformation, orderName: string) => void;
};

const EnterOrderDialog = ({
  open,
  onClose,
  onConfirm,
}: EnterOrderDialogProps) => {
  const [orderName, setOrderName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [cannotAddGreetError, setCannotAddGreetError] = useState(false);

  const handleOrderNameChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setIsError(false);
    setCannotAddGreetError(false);
    setOrderName(event.target.value);
  };

  const handlePressAdd = async () => {
    try {
      setIsLoading(true);
      const giftInfo = await giftClient.getGift({ orderName });
      if (giftInfo?.clockInfo?.registerProduct && !giftInfo?.gift) {
        setCannotAddGreetError(true);
        setIsLoading(false);
        return;
      }
      if (giftInfo) {
        setIsLoading(false);
        onConfirm(giftInfo, orderName);
      }
    } catch {
      setIsLoading(false);
      setIsError(true);
    }
  };

  const handleClose = () => {
    setIsError(false);
    setCannotAddGreetError(false);
    setOrderName('');
    onClose();
  };

  return (
    <DSDialog open={open} onClose={handleClose}>
      <DSBox
        sx={{ padding: 3, display: 'flex', flexDirection: 'column', gap: 2 }}
      >
        <DSTypography
          sx={{
            fontFamily: 'Gilroy-Medium',
            fontSize: '24px',
            fontWeight: 400,
          }}
        >
          Enter Order Name
        </DSTypography>
        <DSTextField
          placeholder="P2335555"
          onChange={handleOrderNameChange}
          value={orderName}
        />
        {isError && (
          <DSTypography
            sx={{ fontFamily: 'Gilroy-Medium', fontSize: '14px' }}
            color="error"
          >
            Order not found
          </DSTypography>
        )}
        {cannotAddGreetError && (
          <DSTypography
            sx={{ fontFamily: 'Gilroy-Medium', fontSize: '14px' }}
            color="error"
          >
            Cannot add greet to order with registered clock
          </DSTypography>
        )}
      </DSBox>
      <DSDialogActions sx={{ justifyContent: 'flex-end', padding: 3, gap: 2 }}>
        <DSSecondaryButton onClick={handleClose}>Cancel</DSSecondaryButton>
        <DSPrimaryButton
          onClick={handlePressAdd}
          disabled={!orderName}
          sx={{ padding: '14px 40px' }}
        >
          {isLoading ? (
            <DSCircularProgress size={20} sx={{ color: KLYDO_BLACK }} />
          ) : (
            'Add'
          )}
        </DSPrimaryButton>
      </DSDialogActions>
    </DSDialog>
  );
};

export default EnterOrderDialog;
